export default "<div class=\"row\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n"